// extracted by mini-css-extract-plugin
export var rateTable = "_50-0";